import { WcsOmnichannel } from '@/scripts/libs/wcs/types/wcs-config'
import wcs from '@/scripts/libs/wcs'
import { Service, ServiceOption } from '../types/omnichannel'
import { WcsStoreId } from '@/scripts/libs/wcs/types/store-id'

const { storeId } = wcs.getStoreConfig()

export class Omnichannel {
  static mapOmnichannelFromStoreconf = (wcsOmnichannel: WcsOmnichannel): Service[] => {
    const omnichannel: Service[] = []
    if (wcsOmnichannel.supportServices) {
      const supportServices: Service = {
        title: 'support_services',
        icon: 'courtesy-lp-support',
        options: this.mapServiceOptions(wcsOmnichannel.supportServices),
      }

      if (supportServices.options.length > 0) {
        omnichannel.push(supportServices)
      }
    }

    if (wcsOmnichannel.inStoreServices) {
      const inStoreServices: Service = {
        title: 'in_store_services',
        icon: 'pickup',
        options: this.mapServiceOptions(wcsOmnichannel.inStoreServices),
      }

      if (inStoreServices.options.length > 0) {
        omnichannel.push(inStoreServices)
      }
    }

    if (wcsOmnichannel.deliveryServices) {
      const deliveryServices: Service = {
        title: 'delivery_services',
        icon: 'delivery',
        options: this.mapServiceOptions(wcsOmnichannel.deliveryServices),
      }

      if (deliveryServices.options.length > 0) {
        const isStoreROE = storeId === WcsStoreId.REST_OF_EUROPE

        if (!isStoreROE) {
          const mappedDeliveryServices = {
            ...deliveryServices,
            options: deliveryServices.options.map((option) => {
              if (option.title === 'discover_all_services') {
                return {
                  ...option,
                  isHighlighted: true,
                }
              }

              return option
            }),
          }

          omnichannel.push(mappedDeliveryServices)
        }
      }
    }

    if (wcsOmnichannel.discoverAllServices) {
      const discoverAllServices: Service = {
        title: '',
        options: this.mapServiceOptions(wcsOmnichannel.discoverAllServices),
      }

      const mappedDiscoverAllServices = {
        ...discoverAllServices,
        options: discoverAllServices.options.map((option) => {
          if (option.title === 'discover_all_services') {
            return {
              ...option,
              isHighlighted: true,
            }
          }

          return option
        }),
      }

      omnichannel.push(mappedDiscoverAllServices)
    }
    return omnichannel
  }

  private static mapServiceOptions = (service: string): ServiceOption[] => {
    const services = service.split('|')
    return services.map((service) => {
      const splitService = service.split(',')
      return {
        title: splitService[0],
        url: splitService[1],
        analytics: splitService[2],
      }
    })
  }
}
